module.exports = __webpack_public_path__ + "media/assets/images/conference_room_forms/block-form-1f4bcf8ba20da124a1a91228fe6720eb.gif";